import React from "react";
import MultiBlogs from "../Components/BlogPages/MultiBlogs"; 

function BlogIndex() {
  return (
    <>
      <main>
        <article id="fullpage">
          <MultiBlogs />
        </article>
      </main>
    </>
  );
}

export default BlogIndex;
